export const fieldsTranslationsFr = {
  'fields-parameters.navbar.services.title': 'Services',
  'fields-parameters.title': 'Paramètres des parcelles',
  'fields-parameters.services.table.title': 'Parcelles',
  'service.field_parameters.column.farmer_name.label': 'Exploitation',
  'service.field_parameters.column.field_number.label': 'Nombre de parcelles',
  'service.field_parameters.column.total_area.label': 'Surface totale (ha)',
  'service.field_parameters.detail_panel.column.field_name.label': 'Nom de la parcelle',
  'service.field_parameters.detail_panel.column.area.label': 'Surface (ha)',
  'service.field_parameters.detail_panel.column.service.label': 'Service',
  'service.field_parameters.detail_panel.column.crop.label': 'Culture',
  'service.field_parameters.detail_panel.column.subscription.label': 'Abonnement',
  'service.field_parameters.detail_panel.column.subscription.active.label': 'Actif',
  'service.field_parameters.detail_panel.column.subscription.no_subscription.label': "Pas d'abonnement",
  'service.field_parameters.detail_panel.column.service.button.parameter.label': 'Paramètres',
  'irrigation_field_service_parameters.button.undo.label': 'Annuler les modifications',
  'irrigation_field_service_parameters.button.save.label': 'Enregistrer les modifications',
  'irrigation_field_service_parameters.multiple_edition.button.apply.label': 'Appliquer',
  'irrigation_field_service_parameters.multiple_edition.button.clear.label': 'Effacer',
  'irrigation_field_service_parameters.multiple_edition.title.label': 'Édition de plusieurs parcelles',
  'irrigation_field_service_parameters.multiple_edition.info.setp1':
    '1- Remplissez les champs que vous souhaitez appliquer à plusieurs parcelles.',
  'irrigation_field_service_parameters.multiple_edition.info.setp2':
    '2- Sélectionnez les parcelles pour lesquelles vous souhaitez appliquer les paramètres.',
  'irrigation_field_service_parameters.multiple_edition.info.setp3':
    "3- Validez en cliquant sur le bouton 'Appliquer' (Attention des erreurs peuvent apparaitre en rouge en cas d'incohérences).",
  'irrigation_field_service_parameters.multiple_edition.info.setp4': '4- Sauvegardez pour appliquer la mise a jour.',
  'irrigation_field_service_parameters.table.Column.farmer_name.label': 'Exploitation',
  'irrigation_field_service_parameters.table.Column.field_number.label': 'Nombre de parcelles',
  'irrigation_field_service_parameters.table.Column.total_area.label': 'Surface totale (ha)',
  'irrigation_field_service_parameters.table.detail_panel.column.field.label': 'Parcelle',
  'irrigation_field_service_parameters.table.detail_panel.column.soil.label': 'Sol',
  'irrigation_field_service_parameters.table.detail_panel.column.weather_station.label': 'Station météo',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_management.label':
    "Gestion de l'irrigation",
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_threshold.label': "Seuil d'irrigation",
  'irrigation_field_service_parameters.table.detail_panel.column.assolment.label': 'Assolement',

  'fields-parameters.navbar.services_parameters.title': 'Paramètres des services',
  'fields-parameters.navbar.crops_soil_parameters.title': 'Cultures et sols',
  'fields-parameters.dialog.error.title': 'Erreur lors de la sauvegarde',
  'fields-parameters.dialog.error.legend':
    "Certaines de vos modifications ont rencontré des erreurs et n'ont pas été sauvegardées.",
  'fields-parameters.dialog.error.contact':
    "Si le problème persiste, merci de transmettre ces erreurs à notre service support à l'adresse csm@pixagri.fr",
};
